export default "__VITE_ASSET__DTfetHE1__"